if ($('#category-header').length) {
    function mhfilter() {
      if($('.filterTitle').length<1){
        $('#filters-wrapper').prepend('<h3 class="filterTitle">Filtrování produktů</h3>')
      }
      $('.slider-wrapper').addClass('filter-section').appendTo('.filter-sections #category-filter-hover').append('<div class="price-filter"></div>');
      $('.slider-wrapper .slider-header').appendTo('.slider-wrapper .price-filter');
      $('.slider-wrapper .slider-content').appendTo('.slider-wrapper .price-filter');
      $('.filter-section h4').click(function () {
        $('.filter-section').not($(this).closest('.filter-section')).removeClass('openFilter').removeAttr('style');
        var section = $(this).closest('.filter-section');
        section.toggleClass('openFilter');
        var formHeight = section.find('form').length ? section.find('form').outerHeight() : section.find('.slider-content').outerHeight() + section.find('.price-filter').outerHeight();

        if (section.hasClass('openFilter')) {
            section.attr('style', 'padding-bottom:' + formHeight + 'px');
        } else {
            section.removeAttr('style');
        }
      });
   
      if ($('.selected-filters').length === 0) {
            $('<div class="selected-filters"></div>').insertBefore('#category-header');
            $('.filter-label.active').clone().appendTo('.selected-filters');
            $('.selected-filters .filter-label.active').closest('div').addClass('active-filter');
            $('.selected-filters .filter-section fieldset div:not(.active-filter)').remove();
            $('#clear-filters').clone().appendTo('.selected-filters')
      }
      var letterSet = new Set();
      $('#manufacturer-filter input[data-filter-id]').each(function () {
        var filterId = $(this).data('filter-id');
        if (filterId) {
          letterSet.add(filterId.charAt(0).toUpperCase());
        }
      });
      var letters = Array.from(letterSet).sort();
      var $lettersDiv = $('<div class="manufacturer-letters"></div>');
      letters.forEach(function (letter) {
        $lettersDiv.append('<span class="manufacturer-letter">' + letter + '</span>');
      });
      if(!$('.manufacturer-letters').length){
        $('#manufacturer-filter form').prepend($lettersDiv);
      }
     
      var activeLetters = [];
      $('#manufacturer-filter input[data-filter-id]:checked').each(function () {
        var filterId = $(this).data('filter-id');
        if (filterId) {
          var firstLetter = filterId.charAt(0).toUpperCase();
          if (!activeLetters.includes(firstLetter)) {
            activeLetters.push(firstLetter);
          }
        }
      });
      var firstLetter;
      if (activeLetters.length > 0) {
        firstLetter = activeLetters[0];
      } else {
        firstLetter = letters[0];
      }
      $('#manufacturer-filter form fieldset div').hide();
      $('#manufacturer-filter input[data-filter-id]').each(function () {
        var filterId = $(this).data('filter-id');
        if (filterId && filterId.charAt(0).toUpperCase() === firstLetter) {
          $(this).closest('div').show();
        }
      });
      $('.manufacturer-letter').removeClass('ActiveLetter');
      $('.manufacturer-letter').each(function () {
        if ($(this).text() === firstLetter) {
          $(this).addClass('ActiveLetter');
        }
      });
      letters.forEach(function (letter) {
        var anyChecked = $('#manufacturer-filter input[data-filter-id]').filter(function () {
          var fid = $(this).data('filter-id');
          return fid.charAt(0).toUpperCase() === letter && $(this).is(':checked');
        }).length > 0;
        if (anyChecked) {
          $('.manufacturer-letter').filter(function () {
            return $(this).text() === letter;
          }).addClass('clickedLetter');
        }
      });
      $('.manufacturer-letter').on('click', function (e) {
        e.preventDefault();
        var selectedLetter = $(this).text();
        $('.manufacturer-letter').removeClass('ActiveLetter');
        $(this).addClass('ActiveLetter');
        $('#manufacturer-filter form fieldset div').hide();
        $('#manufacturer-filter input[data-filter-id]').each(function () {
          var filterId = $(this).data('filter-id');
          if (filterId && filterId.charAt(0).toUpperCase() === selectedLetter) {
            $(this).closest('div').show();
          }
        });
      });
      $('#manufacturer-filter input[data-filter-id]').on('change', function () {
        var filterId = $(this).data('filter-id');
        var firstLetter = filterId.charAt(0).toUpperCase();
        var $letterLink = $('.manufacturer-letter').filter(function () {
          return $(this).text() === firstLetter;
        });
  
        var anyChecked = $('#manufacturer-filter input[data-filter-id]').filter(function () {
          var fid = $(this).data('filter-id');
          return fid.charAt(0).toUpperCase() === firstLetter && $(this).is(':checked');
        }).length > 0;
  
        if (anyChecked) {
          $letterLink.addClass('clickedLetter');
        } else {
          $letterLink.removeClass('clickedLetter');
        }
      });
    }
  
    $(document).ready(function () {
      mhfilter();
    });
    document.addEventListener('ShoptetDOMContentLoaded', function () {
      mhfilter();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
      $('.filter-section h4').click(function () {
        $('.filter-section').not($(this).closest('.filter-section')).removeClass('openFilter').removeAttr('style');
        var section = $(this).closest('.filter-section');
        section.toggleClass('openFilter');
        var formHeight = section.find('form').length ? section.find('form').outerHeight() : section.find('.slider-content').outerHeight() + section.find('.price-filter').outerHeight();

        if (section.hasClass('openFilter')) {
            section.attr('style', 'padding-bottom:' + formHeight + 'px');
        } else {
            section.removeAttr('style');
        }
      });
    });
    document.addEventListener('ShoptetPageFilterValueChange', function () {
      mhfilter();
    });
    
}  